import { render } from "./Show.vue?vue&type=template&id=114cc189"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/parent/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "114cc189"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('114cc189', __exports__)) {
    console.log('reload')
    api.reload('114cc189', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=114cc189", () => {
    console.log('re-render')
    api.rerender('114cc189', render)
  })

}


export default __exports__